var map = {
	"./relvado/1.png": "3c38",
	"./relvado/10.png": "7093",
	"./relvado/11.png": "d6bf",
	"./relvado/12.png": "1b68",
	"./relvado/2.png": "9019",
	"./relvado/3.png": "0674",
	"./relvado/4.png": "34b4",
	"./relvado/5.png": "42ab",
	"./relvado/6.png": "7e38",
	"./relvado/7.png": "d94c",
	"./relvado/8.png": "08de",
	"./relvado/9.png": "8c14",
	"./relvado/full_segmented.png": "1ffe",
	"./relvado/relvado_en.jpg": "68af",
	"./relvado/relvado_es.jpg": "304f",
	"./relvado/relvado_fr.jpg": "cd4e",
	"./relvado/relvado_pt.jpg": "fcb0",
	"./relvado/separados/1.png": "b6d6",
	"./relvado/separados/10.png": "7d65",
	"./relvado/separados/11.png": "de8c",
	"./relvado/separados/12.png": "1534",
	"./relvado/separados/2.png": "f947",
	"./relvado/separados/3.png": "4dcc",
	"./relvado/separados/4.png": "a598",
	"./relvado/separados/5.png": "8c5a",
	"./relvado/separados/6.png": "9146",
	"./relvado/separados/7.png": "31a0",
	"./relvado/separados/8.png": "822b",
	"./relvado/separados/9.png": "ebaf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ffe";